'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mute;

var _UpdateState = require('../VideoStore/UpdateState');

var _UpdateState2 = _interopRequireDefault(_UpdateState);

var _players = require('../../store/actions/players');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

function mute(muted) {
  var players = _store2.default.storeInstance().getState().players;
  var playerId = Object.keys(players)[0];
  _store2.default.storeInstance().dispatch((0, _players.setMute)(playerId, muted));
} /**
   * Copyright 2013-2015, Hudl
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * @providesModule Mute
   */

// There is a really weird bug where if I don't have this import here
// the entire app crashes on some sort of race condition. Keeping
// this here fixes it. Since this file is temporary, I'm saying it's fine
// for this hack to be here.
module.exports = exports['default'];